import { render, staticRenderFns } from "./pph.vue?vue&type=template&id=b36fb1a4"
import script from "./pph.vue?vue&type=script&lang=js"
export * from "./pph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports